/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-15 12:00:23
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-01 14:30:48
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/index.tsx
 */
import SettingsPage from '@/src/components/SettingsPage';
import { isUserValidOr } from '@/src/tools/getUserInfo';
import { EPermissionSource } from '@/src/types/common/resources';
import React from 'react';
import { breadcrumbData } from './config';
import { union } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  communicationDetailPage,
  communicationListPage,
  currencyPage,
  developerPage,
  fileLibraryDetailPage,
  fileLibraryListPage,
  invoicePage,
  linkLibraryDetailPage,
  linkLibraryListPage,
  localizationPage,
  logisticsSettingPage,
  orderSettingPage,
  paymentListPage,
  productSettingPage,
  storeDetailPage,
  tagManagementPage,
  taxListPage,
  thirdPartyPage,
  userPage,
} from '@/src/tools/permissions/storePermissions';
function Settings() {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const settings = [
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.fileLibrary'),
      desc: getI18n('settings.list.fileLibraryTip'),
      linkTo: '/settings/fileLibrary',
      resourcesGroup: union(fileLibraryDetailPage, fileLibraryListPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.storeDetails'),
      desc: getI18n('settings.list.storeDetailsTip'),
      linkTo: '/settings/storeDetails',
      resourcesGroup: union(storeDetailPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.developerSetting'),
      desc: getI18n('settings.list.developerSettingTip'),
      linkTo: '/settings/developer',
      resourcesGroup: union(developerPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.linkLibrary'),
      desc: getI18n('settings.list.linkLibraryTip'),
      linkTo: '/settings/linkLibrary',
      resourcesGroup: union(linkLibraryDetailPage, linkLibraryListPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.invoice'),
      desc: getI18n('settings.list.invoiceTip'),
      linkTo: '/settings/invoice',
      resourcesGroup: union(invoicePage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.currency'),
      desc: getI18n('settings.list.currencyTip'),
      linkTo: '/settings/currency',
      resourcesGroup: union(currencyPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.product'),
      desc: getI18n('settings.list.productTip'),
      linkTo: '/settings/product',
      resourcesGroup: union(productSettingPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.order'),
      desc: getI18n('settings.list.orderTip'),
      linkTo: '/settings/order',
      resourcesGroup: union(orderSettingPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.taxes'),
      desc: getI18n('settings.list.taxesTip'),
      linkTo: '/settings/tax/list',
      resourcesGroup: union(taxListPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.logistics'),
      desc: getI18n('settings.list.logisticsTip'),
      linkTo: '/settings/logistics',
      resourcesGroup: union(logisticsSettingPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.payment'),
      desc: getI18n('settings.list.paymentTip'),
      linkTo: '/settings/payment/list',
      resourcesGroup: union(paymentListPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.localisation'),
      desc: getI18n('settings.list.localisationTip'),
      linkTo: '/settings/localisation',
      resourcesGroup: union(localizationPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.third-PartyAPI'),
      desc: getI18n('settings.list.third-PartyAPITip'),
      linkTo: '/settings/3rdPartyApi',
      resourcesGroup: union(thirdPartyPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.storeTagManager'),
      desc: getI18n('settings.list.storeTagManagerTip'),
      linkTo: '/settings/tagManager',
      resourcesGroup: union(tagManagementPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.communication'),
      desc: getI18n('settings.list.communicationTip'),
      linkTo: '/settings/communicationsList',
      resourcesGroup: union(communicationDetailPage, communicationListPage),
    },
    {
      icon: 'iconsettings',
      name: getI18n('settings.list.usersandPermissions'),
      desc: getI18n('settings.list.usersandPermissionsTip'),
      linkTo: '/settings/permissionsList',
      resourcesGroup: union(userPage),
    },
  ];

  return (
    <React.Fragment>
      <SettingsPage
        breadcrumbData={breadcrumbData({ getI18n })}
        settings={settings.reduce((p, c) => {
          if (
            isUserValidOr({
              source: EPermissionSource.store,
              resourcesGroup: c.resourcesGroup,
            })
          ) {
            return p.concat(c);
          }

          return p;
        }, [])}
      />
    </React.Fragment>
  );
}
export default Settings;
